import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

// Corrected the link paths by adding the '/app' prefix.
const cards = [
  {
    title: '請求書CSVアップロード',
    description: '請求書CSVのアップロードに関する問題はこちら',
    link: '/app/support/troubleshooting/invoice-upload-errors', // Fixed link
  },
  {
    title: '顧客CSVアップロード',
    description: '顧客CSVのアップロードに関する問題はこちら',
    link: '/app/support/troubleshooting/customer-upload-errors', // Fixed link
  },
  {
    title: '顧客データ削除',
    description: '顧客データの削除に関する問題はこちら',
    link: '/app/support/troubleshooting/customer-delete-errors', // Fixed link
  },
];

const Card = ({ title, description, link }) => (
  <Link to={link} className="block bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
    <div className="flex justify-between items-center">
      <div>
        <h3 className="text-xl font-bold text-gray-800">{title}</h3>
        <p className="text-gray-600 mt-2">{description}</p>
      </div>
      <ChevronRightIcon className="h-6 w-6 text-gray-400" />
    </div>
  </Link>
);

const Troubleshooting = () => {
  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        エラートラブル対応
      </h1>
      <div className="space-y-4">
        {cards.map(card => (
          <Card key={card.title} {...card} />
        ))}
      </div>
    </div>
  );
};

export default Troubleshooting;
